class ImageLibrary {

  constructor(app, container, imageCssVar) {
    this.app = app;
    this.container = container;
  }

}


class Uploader {
  constructor(app, container, options, callback) {
    this.app = app;
    this.container = container;
    this.options = {...this.defaults, ...options};
    this.uploadCallback = callback;
    this.inProgress = false;
  }

  defaults = {
    namespace: 'example', // Namespace for dropify instance
    title: 'Upload Image', // Title for the input field
    input: 'imageInput', // ID and name of the input field
    preview: true,
    autoupload: false,
    accept : 'image/jpeg, image/png, image/gif',
    multiple: true, button: {
      remove: {
        text: 'Remove Image' // Text for remove button
      }, save: {
        text: 'Upload Image' // Text for upload button
      }
    }
  }

  renderPreview(data) {
    const row = _.template(this.app.templates['global__row-uploader']);
    const postImage = _.template(this.app.templates['image_library__image-card']);
    data.imageCard = postImage(data);

    const $row = $(row(data));
    this.previewContainer.append($row);
    return $row;
  }

  clearPreview() {
    this.removeFlashMessage();
    this.previewContainer.empty();
  }

  preview(file) {
    file.previewId = this.app.generateId();
    file.messageIndex = 0;

    const self = this;
    const reader = new FileReader();
    const image = new Image();
    const $row = self.renderPreview({
      'id': file.previewId,
      'image': '',
      'name': '',
      'pathThumbnail': '',
      'path': '',
      'config': {},
      'size': this.formatFileSize(file.size)
    });

    reader.readAsDataURL(file);
    reader.onload = function (_file) {
      const srcBase64 = _file.target.result;
      const name = file.name;
      const checkbox = $row.find('input');

      image.src = srcBase64;

      $row.find('.infinite-item').attr('data-org-src', srcBase64);
      $row.find('[data-file-name]').text(name);

      checkbox.css({'background-image': `url(${srcBase64})`});

      image.onload = function (e) {
        checkbox.addClass('loaded');
      };
    };
  }

  messages = ["Uploading...", "Still working on it", "Just a bit more...", "Almost done..."];

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  formatFileSize(bytes) {
    if (bytes < 1024) {
      return bytes + ' bytes';
    } else if (bytes < 1024 * 1024) {
      return (bytes / 1024).toFixed(2) + ' KB';
    } else {
      return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
    }
  }

  updateProgressBar(progressBar, val) {
    progressBar.value = val;
    // workaround Safari bug not updating the UI
    progressBar.replaceWith(progressBar);
  }

  updatePreview(file, value = 1, message = '') {
    const self = this;
    const messages = this.messages;
    const $progress = $(`[data-id="${file.previewId}"] .progress-container`, this.container);
    const $previewText = $progress.find('.progress-text');
    const $progressBar = $progress.find('progress');
    const progressBar = $progressBar[0];
    const $info = $progress.find('.btn-upload-info');
    $progressBar.show();

    $previewText.text(messages[file.messageIndex++]);

    if (value === false) {
      clearInterval(file.intervalId);
      self.updateProgressBar(progressBar, 100);
      $previewText.text('Error');
      $info.attr('data-bs-original-title', message);
    } else if (value === 100) {
      clearInterval(file.intervalId);
      self.updateProgressBar(progressBar, 100);
      $previewText.text('Completed');
      $info.attr('data-bs-original-title', message);
    } else {
      $progressBar.val(value);
      $info.attr('data-bs-original-title', 'Uploading...');
      file.intervalId = setInterval(function () {
        const val = $progressBar.val();
        self.updateProgressBar(progressBar, $progressBar.val() + 1);
        if (val % 15 === 0) {
          $previewText.text(messages[file.messageIndex++]);
        }
        if (val >= 100) clearInterval(file.intervalId)
      }, 200);
    }

    return $progress;
  }

  removeFlashMessage() {
    const $el = $('#uploadInProgressMessage');
    if ($el.length) {
      $el.remove();
    }
  }

  flashMessage() {
    this.removeFlashMessage();
    const template = `<div id="uploadInProgressMessage" class="alert text-center alert-danger loader-with-messages position-absolute top-0 w-100">
            <p>Your file is currently being uploaded. Please wait...</p>
            <p>Please do not reload the browser or navigate away from this page until the upload is complete or this message disappears.</p>
          </div>`;

    const row = _.template(template);
    const $row = $(row({}));
    const $dropify = $('.dropify-wrapper', this.container)
    $row.insertAfter($dropify);
  }

  flashErrorMessage() {
    this.removeFlashMessage();
    const template = `<div id="uploadInProgressMessage" class="alert text-center alert-danger  position-absolute top-0 w-100">
            <p>There are some errors during one or more uploads</p>
            <p>Please check and try to upload again.</p>
          </div>`;

    const row = _.template(template);
    const $row = $(row({}));
    const $dropify = $('.dropify-wrapper', this.container)
    $row.insertAfter($dropify);
  }


  flashFileCsvMessage() {
    this.removeFlashMessage();
    const template = `<div id="uploadInProgressMessage" class="alert text-center alert-danger loader-with-messages position-absolute top-0 w-100">
            <p>Your file is currently being processed. Please wait...</p>
            <p>Please do not reload the browser or navigate away from this page until the upload is complete or this message disappears.</p>
          </div>`;

    const row = _.template(template);
    const $row = $(row({}));
    const $dropify = $('.dropify-wrapper', this.container)
    $row.insertAfter($dropify);
  }

  hasError() {
    return this.fileUploadError;
  }

  async upload(files) {
    this.inProgress = true;
    this.flashMessage();
    this.files = {...this.files, ...files};
    for (const file of files) {
      let response;
      const $progress = this.updatePreview(file);
      $progress[0].scrollIntoView({behavior: 'smooth', block: 'center', inline: 'nearest'});

      try {
        response = await this.app.apis['uploads'].upload(file);
        //response = await this.sleep(10000);
        this.updatePreview(file, 100, response.message);
      } catch (error) {
        response = error;
        this.fileUploadError = true;
        this.updatePreview(file, false, error.message.message);
      }
      file.response = response;
    }

    return files;
  }

  uploadInProgress() {
    return this.inProgress;
  }

  handleFiles(files) {
    const self = this;
    files = [...files];
    files.forEach(this.preview.bind(this));
    this.upload(files).then(function (response) {
      self.inProgress = false;
      self.removeFlashMessage();

      if (self.hasError()) {
        self.flashErrorMessage();
      }

      if (typeof self.uploadCallback === 'function') {
        self.uploadCallback(response);
      }
    });
    let tooltip = $('[data-bs-toggle="tooltip"]').tooltip();
  }


  dropify() {
    const self = this;
    const uploader = _.template(this.app.templates['global__uploader']);
    const $uploader = $(uploader(this.options));
    this.container.append($uploader);

    const $actions = $('.dropify-actions', this.container);
    const $input = $('input[type=file]', this.container);
    this.previewContainer = $('[data-files-preview]', this.container);

    this.dropfiy = $input.dropify({
      messages: {
        'default': '<span class="main-text">Click or Drop files here to upload</span><span class="sub-text"> The app will only accepts jpg, jpeg, and png file formats with a max file size of 10mb. For best results use images which are alteast 1200px wide</span>',
        'replace': 'Drag and drop or click to replace',
        'remove': 'Remove',
        'error': 'Ooops, something wrong happended.'
      }, tpl: {
        message: '<div class="dropify-message"><span class="file-icon"></span> <p>{{ default }}</p></div>',
      }
    });


    // Event handler for after a file has been cleared.
    this.dropfiy.on('dropify.afterClear', function (event, element) {
      $actions.addClass('d-none');
    });

    // Event handler for when a file is ready after being selected.
    this.dropfiy.on('dropify.fileReady', function (event, element) {
      $actions.addClass('d-none');
      const $uploadImage = $('.dropify-actions.btn-upload-image');
      $uploadImage.removeClass('d-none');
    });

    $input.on('change', function (event) {
      event.preventDefault();
      // Get the files
      const files = event.target.files;
      self.handleFiles(files);
      return event.preventDefault();
    });
  }

  dropifySingle(removeCallback, uploadCallback) {
    const self = this;
    const $container = this.container;
    const uploader = _.template(this.app.templates['global__uploader']);
    const $uploader = $(uploader(this.options));
    $container.append($uploader);
    const $input = $(`input[type=file]`, $container)

    this.dropfiy = $input.dropify({
      messages: {
        'default': '<span class="main-text">Click or Drop files here to upload</span><span class="sub-text"> The app will only accepts jpg, jpeg, and png file formats with a max file size of 10mb. For best results use images which are alteast 1200px wide</span>',
        'replace': 'Drag and drop or click to replace',
        'remove': 'Remove',
        'error': 'Ooops, something wrong happended.'
      }, tpl: {
        message: '<div class="dropify-message"><span class="file-icon"></span> <p>{{ default }}</p></div>',
      }
    });

    this.dropfiy.on('dropify.beforeClear', function (event, element) {
      if (self.app.isEmpty(event.filename)) {
        return event.preventDefault();
      }
      console.log(event.filename);
    });

    // Event handler for after a file has been cleared.
    this.dropfiy.on('dropify.afterClear', function (event, element) {
      const $input = $(event.currentTarget);
      const $container = $input.closest('.dropify-uploader');
      const $message = $('.dropify-message', $container);
      const $actions = $('.dropify-actions', $container);
      $message.show();
      $actions.addClass('d-none');

      //
      // if (typeof removeCallback === 'function' && self.options.autoupload) {
      //   removeCallback($input).then(function () {
      //
      //   });
      // } else {
      //   const $message = $('.dropify-message', $container);
      //   const $actions = $('.dropify-actions', $container);
      //   $message.show();
      //   $actions.addClass('d-none');
      // }
    });

    // Event handler for when a file is ready after being selected.
    this.dropfiy.on('dropify.fileReady', function (event, element) {
      const $input = $(event.currentTarget);
      const $container = $input.closest('.dropify-uploader');
      const $uploadButton = $('.btn-upload-image', $container);
      const $message = $('.dropify-message', $container);
      const $actions = $('.dropify-actions', $container);
      $actions.addClass('d-none');
      $message.hide();
      $uploadButton.removeClass('d-none');
    });


    this.container.on('click', '.btn-remove-image', function (e) {
      const $button = $(this);
      const $input = $(`input[type=file]`, $button.closest('.dropify-uploader'))
      if (typeof removeCallback === 'function') {
        removeCallback($input, $button);
      }
    });

    this.container.on('click', '.btn-upload-image', function () {
      const $button = $(this);
      const $input = $(`input[type=file]`, $button.closest('.dropify-uploader'))
      if (typeof uploadCallback === 'function') {
        uploadCallback($input, $button);
      }
    });

    if (this.options.autoupload) {
      $input.on('change', function (event) {
        event.preventDefault();
        const $inputEl = $(event.currentTarget);
        const $uploadButton = $inputEl.closest('.dropify-uploader').find('.btn-upload-image');
        $uploadButton.removeClass('d-none');
        uploadCallback($inputEl, $uploadButton).then(function () {

        });
        return event.preventDefault();
      });

    }
  }

  dropifyFile(uploadCallback, removeCallback) {
    const self = this;
    const $container = this.container;
    const uploader = _.template(this.app.templates['global__uploader']);
    //console.log(this.options);

    const $uploader = $(uploader(this.options));
    $container.append($uploader);
    const $input = $(`input[type=file]`, $container)

    this.dropfiy = $input.dropify({
      messages: {
        'default': '<span class="main-text">Click or Drop files here to upload</span><span class="sub-text"> The app will only accepts csv file format with a max file size of 10mb.</span>',
        'replace': 'Drag and drop or click to replace',
        'remove': 'Remove',
        'error': 'Ooops, something wrong happended.'
      }, tpl: {
        message: '<div class="dropify-message"><span class="file-icon"></span> <p>{{ default }}</p></div>',
      }
    });

    this.dropfiy.on('dropify.beforeClear', function (event, element) {
      if (self.app.isEmpty(event.filename)) {
        return event.preventDefault();
      }
      console.log(event.filename);
    });

    // Event handler for after a file has been cleared.
    this.dropfiy.on('dropify.afterClear', function (event, element) {
      const $input = $(event.currentTarget);
      const $container = $input.closest('.dropify-uploader');
      const $message = $('.dropify-message', $container);
      const $actions = $('.dropify-actions', $container);
      $message.show();
      $actions.addClass('d-none');
    });

    // Event handler for when a file is ready after being selected.
    this.dropfiy.on('dropify.fileReady', function (event, element) {
      const $input = $(event.currentTarget);
      const $container = $input.closest('.dropify-uploader');
      const $uploadButton = $('.btn-upload-image', $container);
      const $message = $('.dropify-message', $container);
      const $actions = $('.dropify-actions', $container);
      $actions.addClass('d-none');
      $message.hide();
      $uploadButton.removeClass('d-none');
    });


    if (this.options.autoupload) {
      $input.on('change', function (event) {
        event.preventDefault();
        const $inputEl = $(event.currentTarget);
        const $uploadButton = $inputEl.closest('.dropify-uploader').find('.btn-upload-image');
        self.flashFileCsvMessage();
        uploadCallback($inputEl, $uploadButton).then(function () {

        });
        return event.preventDefault();
      });

    }
  }
}
